export default {
  activeVersion: 'v1',
  baseUrl: 'https://shared.mediahuis.be/logos/lw/',
  alt: 'Wort',
  v1: {
    main: {
      'brand-main': {
        png: 'brand-main.png',
        svg: 'brand-main.svg'
      },
      'brand-square-main': {
        png: 'brand-square-main.png',
        svg: 'brand-square-main.svg'
      },
      'brand-plus-main': {
        png: 'brand-plus-main.png',
        svg: 'brand-plus-main.svg',
        alt: 'Plus Artikel'
      }
    },
    variations: {
      'brand-icon': {
        png: 'brand-icon.png',
        svg: 'brand-icon.svg'
      },
      'brand-icon-white': {
        png: 'brand-icon-white.png',
        svg: 'brand-icon-white.svg'
      },
      'brand-square-icon-white': {
        png: 'brand-square-icon-white.png',
        svg: 'brand-square-icon-white.svg'
      },
      'brand-name-white': {
        png: 'brand-name-white.png',
        svg: 'brand-name-white.svg'
      },
      'brand-rectangle-name': {
        png: 'brand-rectangle-name.png',
        svg: 'brand-rectangle-name.svg'
      }
    }
  }
};